/**
 * Favorites Model
 */

define(function(require, exports, module) {
    'use strict';

    var BaseModel = require('common/base.model');
    var server = require('server');

    module.exports = BaseModel.extend({

        idAttribute: 'favoriteID',

        defaults: {
            type: 'game'
        },

        parse: function(favoriteID) {
            return {
                favoriteID: favoriteID
            };
        },

        sync: function(method, model, options) {
            if (method === 'create' || method === 'update') {
                return this._create(model, options);
            } else if (method === 'delete') {
                return this._delete(model, options);
            }
        },

        _create: function(model) {
            return server.send({
                ID: 31106,
                description: 'Add in Favorites for IMS analytics',
                requestType: 'add',
                gameTypes: [model.get('favoriteID')],
                responses: [31107, 31108]
            });
        },

        _delete: function(model) {
            return server.send({
                ID: 31106,
                description: 'Remove from Favorites for IMS analytics',
                requestType: 'remove',
                gameTypes: [model.get('favoriteID')],
                responses: [31107, 31108]
            });
        }

    });

});